import { useMutation, useQueryClient } from '@tanstack/react-query';
import { channelsApi } from '../services';

/**
 * Hook to delete a channel
 *
 * @example
 * const deleteChannel = useDeleteChannel();
 * deleteChannel.mutate(channelId);
 */
export const useDeleteChannel = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (id: string) => channelsApi.delete(id),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['channels'] });
    },
  });
};
